import config from '@feature-config/riya/riya/feature.config.json';
import { createFeatureModule } from '../../createFeatureModule';
import type { FeatureModule } from '../../types';
import { RiyaFeature } from './RiyaFeature';

const riyaFeature: FeatureModule = createFeatureModule(config, RiyaFeature, 'riya/riya');

export default riyaFeature;
